export const generateMergedCartData = (cartState) => {
  const { cartItems, menuChoices } = cartState;

  return cartItems.map((item) => {
    if (item.uniqueId && menuChoices[item.uniqueId]) {
      return {
        ...item,
        menuDetails: menuChoices[item.uniqueId]
      };
    }
    return item;
  });
};
